"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_hooks_1 = __importDefault(require("axios-hooks"));
/**
 * useRemoveData is a data remove hook that returns a tuple
 * containing an object with data, loading and error and a function.
 *
 * @param url url of api
 * @param path path of resource
 * @param headers record of header values
 *
 *
 * ```typescript
 *
 * interface Test {
 *  name: string
 *  description: string
 * }
 *
 * const url = 'http://localhost:9000/api'
 *
 * const [{ data, error, loading }, remove] = useRemoveData<Test>({
 *  url,
 *  path: "test"
 * })
 *
 * ```
 */
var useRemoveData = function (_a) {
    var _b = _a.url, url = _b === void 0 ? "" : _b, path = _a.path, headers = _a.headers;
    var _c = __read((0, axios_hooks_1.default)({ method: 'DELETE', headers: headers }, { manual: true }), 2), _d = _c[0], data = _d.data, error = _d.error, loading = _d.loading, execute = _c[1];
    var remove = function (id) {
        execute({ url: "".concat(url, "/").concat(path, "/").concat(id) });
    };
    // @ts-ignore
    return [{ data: data, loading: loading, error: error }, remove];
};
exports.default = useRemoveData;
//# sourceMappingURL=use-remove-data.js.map